export function parseStudentDate(value) {
  if (!value) return null;

  if (value instanceof Date && !Number.isNaN(value.getTime())) return value;

  if (typeof value === "object" && typeof value.seconds === "number") {
    const d = new Date(value.seconds * 1000);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const d = new Date(`${raw}T00:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const slashMatch = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (slashMatch) {
    const month = Number(slashMatch[1]);
    const day = Number(slashMatch[2]);
    const year = Number(slashMatch[3]);
    const d = new Date(year, month - 1, day);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const fallback = new Date(raw);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
}

export function getStudentFirstSessionDate(student) {
  if (!student || typeof student !== "object") return null;
  return (
    parseStudentDate(student.startDate) ||
    parseStudentDate(student.firstSessionDate) ||
    parseStudentDate(student.firstSession) ||
    parseStudentDate(student.createdAt)
  );
}

export function sortStudentsByFirstSessionThenName(students) {
  return [...(students || [])].sort((a, b) => {
    const ad = getStudentFirstSessionDate(a);
    const bd = getStudentFirstSessionDate(b);

    if (ad && bd && ad.getTime() !== bd.getTime()) {
      return bd.getTime() - ad.getTime(); // Flipped for newest first
    }
    if (ad && !bd) return -1; // Keep students with dates at the top
    if (!ad && bd) return 1;

    return String(a?.name || "").localeCompare(String(b?.name || ""));
  });
}

export function formatShortDate(value) {
  const d = parseStudentDate(value);
  if (!d) return "-";
  return d.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" });
}
